module.exports = __webpack_public_path__ + "images/47b6485767c4001c965d4f905cafbb8cf.svg";